import PropTypes from 'prop-types';
import React from 'react';

import DashboardHeader from './dashboardHeader.jsx';
import JumpBack from './jumpBack';

class CompleteDashboardheader extends React.Component {
  render() {
    return (
      <div className="mb-5">
        <DashboardHeader
          timer={this.props.timer}
          resultsSummarized={this.props.resultsSummarized}
          practiceExam={this.props.practiceExam}
          submitPracticeExam={this.props.submitPracticeExam}
          submitPracticeExamSuccess={this.props.submitPracticeExamSuccess}
          setUserCycle={this.props.setUserCycle}
          loadPossibleCyclesForUser={this.props.loadPossibleCyclesForUser}
          possibleCyclesForUser={this.props.possibleCyclesForUser}
          getWeeklyPracticeExams={this.props.getWeeklyPracticeExams}
          resetPracticeExamHistory={this.props.resetPracticeExamHistory}
          userName={this.props.user.username}
          userLastName={this.props.user.lastName}
          rateName={this.props.user.rate ? this.props.user.rate.name : ' '}
          cycle={this.props.data.cycle}
          avatar={
            this.props.user.imgUrl
              ? this.props.user.imgUrl
              : this.props.data.avatarUrl
          }
          dashboardHeaderInfoWaiting={this.props.dashboardHeaderInfoWaiting}
          dashboardHeaderInfo={this.props.dashboardHeaderInfo}
          user={this.props.user}
          loadDashboardHeaderInfo={this.props.loadDashboardHeaderInfo}
          getUserData={this.props.getUserData}
          userSubscription={this.props.userSubscription}
        />
        <JumpBack
          pfeSktIdWaiting={this.props.pfeSktIdWaiting}
          pfeSktId={this.props.pfeSktId}
          chaper={this.props.data.chaper}
          firstTime={this.props.data.firstTime}
          dashboardHeaderInfoWaiting={this.props.dashboardHeaderInfoWaiting}
          dashboardHeaderInfo={this.props.dashboardHeaderInfo}
          user={this.props.user}
        />
      </div>
    );
  }
}

CompleteDashboardheader.propTypes = {
  user: PropTypes.object,
  data: PropTypes.object,
};

export default CompleteDashboardheader;
